<template>
  <BaseDialog
    :showCondition="forgotPasswordDialogState.show"
    @closed="changeForgotPasswordDialogState(false)"
  >
    <template v-slot:title>
      <span class="primary--text">استعادة كلمة السر</span>
    </template>

    <template v-slot:body>
      <v-form ref="form">
        <v-container>
          <v-row justify="center">
            <v-col align="center" cols="9">
              <div class="text-body-1 mb-5">
                أدخل رقم هاتفك المحمول لإرسال رمز التحقق
              </div>
              <BaseTextField
                v-model="phoneNumber"
                class="mt-3"
                label="رقم الهاتف المحمول"
                type="number" 
                placeholder="رقم الهاتف المحمول"
                name="رقم الهاتف المحمول"
                :rules="[requiredRule, phoneNumberRule]"
                @keyup.enter="validateThenSendCode()"
              >
              </BaseTextField>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </template>

    <template v-slot:actions>
      <v-row justify="center">
        <v-col align="center">
          <v-row justify="space-around">
            <v-btn
              @click="validateThenSendCode()"
              class="accent rounded-pill px-10 mb-5"
              :loading="loading"
            >
              إرسال رمز التحقق
            </v-btn>
            <v-btn
              text
              outlined
              rounded
              @click="changeForgotPasswordDialogState(false)"
              class="primary--text mb-5"
            >
              إلغاء
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/core/base/dialogs/BaseDialog.vue";
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "../store/AuthStore";

export default {
  name: "ForgotPasswordDialog",
  components: { BaseDialog },
  data() {
    return {
      phoneNumber: "",
      loading: false,
    };
  },
  computed: {
    ...mapState(useAuthStore, ["forgotPasswordDialogState"]),
  },
  methods: {
    ...mapActions(useAuthStore, [
      "changeForgotPasswordDialogState",
      "changeResetPasswordDialogState",
      "requestPasswordReset",
    ]),
    async validateThenSendCode() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await this.requestPasswordReset({ identifier: this.phoneNumber });
          this.changeForgotPasswordDialogState(false);
          this.changeResetPasswordDialogState(true, this.phoneNumber);
        } catch (error) {
          console.error("Error requesting password reset:", error);
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped></style>
